import { createContext, useContext } from 'react';

// The element in the app header that page titles are rendered into (see
// components/PageTitle.jsx); null until the header has mounted.
export const PageTitleSlotContext = createContext(null);

export const usePageTitleSlot = () => useContext(PageTitleSlotContext);
